//Reducers can be viewed simply as functions that return some data. All these small pieces of data can be used in App wherever required by importing respective Reducers.
import * as _ from 'lodash';

//What you change in here needs a reload!
const initialState = {
	customers: [],
	suppliers: [],
	expenseCategories: [],
	assetCategories: [],
	takingCategories: [],
	profitbymonth: null,
	busDetails: [],
	accounts: [],
	taxCategories: [],
	yrs: null
};

export default function (state = initialState, action) {
	if (action.type === 'CUSTOMERS_LIST_SUCCESS') {
		//Mwaha we can spy on them and grab data as it passes
		__DEV__ && console.log('global CUSTOMERS_LIST_SUCCESS');
		return {
			...state,
			customers: action.list
		};
	}
	if (action.type === 'SUPPLIERS_LIST_SUCCESS') {
		__DEV__ && console.log('global SUPPLIERS_LIST_SUCCESS');
		return {
			...state,
			suppliers: action.list
		};
	}

	if (action.type === 'UPDATE/customer') {
		const inCustomers = _.findIndex(state.customers, ['id', action.id]);
		var customers = state.customers.slice(0);
		__DEV__ && console.log(`UPDATE/customer id ${action.id} found ${inCustomers}`);
		if (inCustomers > -1) {
			var customer = { ...customers[inCustomers], ...action.difference };
			customer.display = customer.businessName ? customer.businessName : customer.name;
			if (action.difference.openingDebt) customer.owes = (customer.owes * 1 + action.difference.openingDebt * 1 - customers[inCustomers].openingDebt * 1).toFixed(2);
			customers[inCustomers] = customer;
		}
		//console.log('customers now', customers);
		return {
			...state,
			customers
		};
	}

	if (action.type === 'UPDATE/supplier') {
		const inCustomers = _.findIndex(state.supplier, ['id', action.id]);
		var suppliers = state.suppliers.slice(0); //just a copy
		__DEV__ && console.log(`UPDATE/customer id ${action.id} found ${inCustomers}`);
		if (inCustomers > -1) {
			var supplier = { ...suppliers[inCustomers], ...action.difference };
			supplier.display = supplier.businessName ? supplier.businessName : supplier.name;
			if (action.difference.openingDebt) supplier.owes = (supplier.owes * 1 + action.difference.openingDebt * 1 - suppliers[inCustomers].openingDebt * 1).toFixed(2);
			suppliers[inCustomers] = supplier;
		}
		__DEV__ && console.log('customers now', suppliers);
		return {
			...state,
			suppliers
		};
	}

	if (action.type === 'UPDATE/account') {
		const inAccounts = _.findIndex(state.accounts, ['id', action.id]);
		var accounts = state.accounts.slice(0);
		__DEV__ && console.log(`UPDATE/account id ${action.id} found ${inAccounts}`);
		if (inAccounts > -1) {
			const account = { ...accounts[inAccounts], ...action.difference };
			accounts[inAccounts] = account;
		}
		//console.log('customers now', customers);
		return {
			...state,
			accounts
		};
	}

	if (action.type === 'INSERT/dailyEntry') {
		//receipt and customer_id -> update customer's last trans (lastAcct, lastPaid, lastPayable, lastTransaction, owes)
		if (action.entry.transaction_type == 'receipt' && action.customer_id) {
			//entry doesn't contain customer_id so sent separately
			__DEV__ && console.log('finding customer for INSERT trans');
			const inCustomers = _.findIndex(state.customers, ['id', action.customer_id]);
			__DEV__ && console.log(inCustomers);
			if (inCustomers == -1) return state;
			var cust = state.customers[inCustomers];
			const owes = Number(cust.owes) + Number(action.entry.payable) - Number(action.entry.paid);
			state.customers[inCustomers] = {
				...state.customers[inCustomers],
				lastAcct: action.entry.account_id,
				lastPaid: action.entry.paid,
				lastPayable: action.entry.payable,
				lastTransaction: action.entry.expenseDate,
				owes
			};
			return {
				...state,
				customers: [...state.customers]
			};
		}
	}

	if (action.type === 'INSERT/customer') {
		return {
			...state,
			customers: _.sortBy([...state.customers, action.values], ['display', 'lastTransaction'])
		};
	}

	if (action.type === 'DELETE/customer') {
		var customers = [...state.customers];
		const inThere = _.findIndex(customers, ['id', action.id]);
		__DEV__ && console.log('found customerr', inThere);
		if (inThere > -1) customers.splice(inThere, 1);

		return {
			...state,
			customers
		};
	}

	if (action.type === 'INSERT/supplier') {
		return {
			...state,
			suppliers: _.sortBy([...state.suppliers, action.values], ['display', 'lastTransaction'])
		};
	}

	if (action.type === 'INSERT/expenseCategory') {
		__DEV__ && console.log(action.entry);
		return {
			...state,
			expenseCategories: [...state.expenseCategories, action.entry]
		};
	}

	if (action.type === 'UPDATE/expenseCategory') {
		const inExpenseCategory = _.findIndex(state.expenseCategories, ['id', action.id]);
		var expenseCategories = state.expenseCategories.slice(0);
		__DEV__ && console.log(`UPDATE/expenseCategories id ${action.id} found ${inExpenseCategory}`);
		if (inExpenseCategory > -1) {
			const account = { ...expenseCategories[inExpenseCategory], ...action.difference };
			expenseCategories[inExpenseCategory] = account;
		}
		//console.log('customers now', customers);
		return {
			...state,
			expenseCategories
		};
	}

	if (action.type === 'DELETE/expenseCategory') {
		var expenseCategories = [...state.expenseCategories];
		const inThere = _.findIndex(expenseCategories, ['id', action.id]);
		__DEV__ && console.log('found expenseCategorie', inThere);
		if (inThere > -1) expenseCategories.splice(inThere, 1);

		return {
			...state,
			expenseCategories
		};
	}

	if (action.type === 'UPDATE/takingCategory') {
		const inCategory = _.findIndex(state.takingCategories, ['id', action.id]);
		var takingCategories = state.takingCategories.slice(0);
		__DEV__ && console.log(`UPDATE/takingCategories id ${action.id} found ${inCategory}`);
		if (inCategory > -1) {
			const account = { ...takingCategories[inCategory], ...action.difference };
			takingCategories[inCategory] = account;
		}
		//console.log('customers now', customers);
		return {
			...state,
			takingCategories
		};
	}

	if (action.type === 'INSERT/takingCategory') {
		__DEV__ && console.log(action.entry);
		return {
			...state,
			takingCategories: [...state.takingCategories, action.entry]
		};
	}

	if (action.type === 'DELETE/takingCategory') {
		var takingCategories = [...state.takingCategories];
		const inThere = _.findIndex(takingCategories, ['id', action.id]);
		__DEV__ && console.log('found takingCategory', inThere);
		if (inThere > -1) takingCategories.splice(inThere, 1);

		return {
			...state,
			takingCategories
		};
	}

	/*if (action.type === "Web/InitLoad") {
		console.log('InitLoad', action);
		return {
			...state,
			//customers: action.data.customerDebts,
			busDetails: action.data.busDetails[0]
			//isLoading: action.isLoading,

		};
	}*/
	if (action.type === 'Init/InitLoad') {
		//console.log('InitLoad', action);
		return {
			...state,
			...action.data
			//isLoading: action.isLoading,
		};
	}
	if (action.type == 'UPDATE/busDetails') {
		var busDetails = {
			...state.busDetails,
			...action.difference
		};
		//console.log('UPDATE/busDetails', busDetails);
		return {
			...state,
			busDetails
			//isLoading: action.isLoading,
		};
	}
	return state;
}
